import { throttle } from 'throttle-debounce';

export const preventDoubleClick = (fn: () => void): (() => void) =>
  // Время анимации слайдера
  throttle(1000, fn, { noTrailing: true });
